import { applyProposalUserAction } from 'api/operations/enrollmentService';
import { action, makeObservable } from 'mobx';
import { createContext, useContext } from 'react';
import { UploadDocumentsModule } from 'store/modules/upload-documents/uploadDocumentsModule';
import UploadDocumentsPageStore, {
  UploadDocumentsDomainData,
} from 'store/modules/upload-documents/uploadDocumentsPageStore';
import { UploadStep } from 'types/documentsService';
import { USER_ACTIONS } from 'types/enrollmentService';

export default class UploadInitiateRFQDocumentsPageStore extends UploadDocumentsPageStore {
  public async completeStep(): Promise<void> {
    this._setIsLoading(true);
    if (!this._domainData.affiliatedId) throw new Error('Period id is missing');
    await this._uploadDocumentsModule.submitDocuments();
    await applyProposalUserAction(
      this._domainData.affiliatedId,
      this._domainData.entityId,
      USER_ACTIONS.COMPLETE_INITIATE_RFQ_DOCUMENTS,
    );
    this._setIsLoading(false);
  }

  constructor(domainData: UploadDocumentsDomainData) {
    super(domainData, UploadStep.INITIATE_RFQ);

    this._uploadDocumentsModule = new UploadDocumentsModule({
      entityId: domainData.entityId,
      affiliatedId: domainData.affiliatedId,
      uploadStep: UploadStep.INITIATE_RFQ,
    });

    makeObservable<UploadInitiateRFQDocumentsPageStore>(this, {
      completeStep: action.bound,
    });
  }
}

const UploadInitiateRFQDocumentsPageStoreContext = createContext(
  new UploadInitiateRFQDocumentsPageStore({
    entityId: 'stub-entity',
    affiliatedId: 'stub-affiliation',
  }),
);

export const useUploadInitiateRFQDocumentsPageStore = (): UploadInitiateRFQDocumentsPageStore => {
  return useContext(UploadInitiateRFQDocumentsPageStoreContext);
};

export { UploadInitiateRFQDocumentsPageStoreContext };
